import React from 'react';
import { logEvent } from '../clientLogs';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logEvent('error', 'UNHANDLED', 'react_error_boundary', {
      message: error.message,
      stack: error.stack?.slice(0, 2000),
      componentStack: info.componentStack?.slice(0, 2000),
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
            <h2>Что-то пошло не так</h2>
            <p>Ошибка отправлена в систему мониторинга. Попробуйте обновить страницу.</p>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
